var n = (e) => {
  throw TypeError(e);
};
var a = (e, t, s) => t.has(e) || n("Cannot " + s);
var b = (e, t, s) => (a(e, t, "read from private field"), s ? s.call(e) : t.get(e)), h = (e, t, s) => t.has(e) ? n("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, s), l = (e, t, s, r) => (a(e, t, "write to private field"), r ? r.call(e, s) : t.set(e, s), s), u = (e, t, s) => (a(e, t, "access private method"), s);
const M = ["id"], c = [...M];
var o, i, p, d;
class A {
  constructor(t, s) {
    h(this, i);
    h(this, o);
    this.attributes = /* @__PURE__ */ new Map(), (this.host = t).addController(this), l(this, o, s);
  }
  hostConnected() {
    u(this, i, p).call(this), u(this, i, d).call(this);
  }
}
o = new WeakMap(), i = new WeakSet(), p = function() {
  var t, s;
  if (this.host instanceof HTMLElement) {
    for (const r of c)
      this.attributes.set(
        r,
        (s = this.host.getAttribute(r)) != null ? s : (t = b(this, o)) == null ? void 0 : t[r]
      );
    this.host.requestUpdate();
  }
}, d = function() {
  const t = new MutationObserver(
    (s, r) => {
      for (const { attributeName: f, target: v } of s)
        f === "id" && this.attributes.set("id", v.id);
      this.host.requestUpdate();
    }
  );
  this.host instanceof HTMLElement && t.observe(this.host, {
    attributes: !0,
    attributeFilter: c
  });
};
export {
  A as P
};
